import classNames from 'classnames'
import type {ReactElement} from 'react'
import React, {useEffect, useState} from 'react'

import styles from './JobAnimationWrapper.css'

type Props = {
  enabled: boolean
  children: ReactElement
}

function JobAnimationWrapper({enabled, children}: Props) {
  const [startAnimation, setStartAnimation] = useState(false)

  useEffect(() => {
    if (enabled) {
      requestAnimationFrame(() => setStartAnimation(true))
    }
  }, [enabled])

  if (enabled) {
    return (
      <div className={classNames(styles.wrapper, {[styles.startAnimation]: startAnimation})}>
        {children}
      </div>
    )
  }

  return children
}

export default JobAnimationWrapper
